import './bradleyhotel/style';
import FormStructure from './bradleyhotel/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js